/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Feed_Commit_RefetchInputs */

const cs_import_feed_commit_refetch = /** @type {(inputs: Import_Feed_Commit_RefetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukládám import…`)
};

const en_import_feed_commit_refetch = /** @type {(inputs: Import_Feed_Commit_RefetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Committing import…`)
};

/**
* | output |
* | --- |
* | "Committing import…" |
*
* @param {Import_Feed_Commit_RefetchInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_feed_commit_refetch = /** @type {((inputs?: Import_Feed_Commit_RefetchInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Feed_Commit_RefetchInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_feed_commit_refetch(inputs)
	return cs_import_feed_commit_refetch(inputs)
});